const Redux = require('redux');

const finalCreateStore = Redux.applyMiddleware(
    require('../middleware/console-middleware'),
    require('../middleware/thunk-middleware')
)(Redux.createStore);

// import and apply reducers here
//
const reducer = Redux.combineReducers({
  app: require('../reducers/app'),
  permissions: require('../reducers/permissionList'),
  header: require('../reducers/header'),
  postal: require('../reducers/postal')
});

module.exports = () => {
    let store = finalCreateStore(reducer);
    window.globalstore = store;
    return store;
};



// WEBPACK FOOTER //
// ./client/src/stores/redux.js